<template>
  <div >
    <md-card >
      <md-card-header>
        <div class="md-title">Solicitar token</div>
      </md-card-header>

      <md-card-content>
        Solicita un token para el uso de los Microservicios

      <md-field v-if="token">
        <label>Token</label>
        <md-textarea disabled  md-autogrow v-model="token" id="token"></md-textarea>

      <md-button title="Copiar" @click="copyText('token')"><md-icon >file_copy</md-icon></md-button>

          
      </md-field>
      </md-card-content>

      <md-card-actions>
      <md-button id="requestToken" @click="request">Solicitar token</md-button>
      </md-card-actions>
    </md-card>
    <md-card >
      <md-card-header>
        <div class="md-title">Mail Microservicio</div>
      </md-card-header>

      <md-card-content>
        Envio de mail por medio de un POST request

      <md-field >
        <md-input disabled :value='mailer'   id="mailer"></md-input>

      <md-button title="Copiar"  @click="copyText('mailer')"><md-icon >file_copy</md-icon></md-button>

          
      </md-field>


      <md-card class="card-inline">

      <md-card-header>
        <div class="md-title">Envio con servidor gmail</div>
      </md-card-header>
        <md-card-content>
          <md-field >
            <md-textarea disabled  md-autogrow :value='mailerBodyGmail'  id="mailerBodyGmail"></md-textarea>


              
          </md-field>

          <md-button title="Copiar"  @click="copyText('mailerBodyGmail')"><md-icon >file_copy</md-icon></md-button>

        </md-card-content>
      </md-card>
      <md-card class="card-inline">

      <md-card-header>
        <div class="md-title">Envio con servidor propio</div>
      </md-card-header>
        <md-card-content>
          <md-field >
            <md-textarea disabled  md-autogrow :value='mailerBodyGeneric'  id="mailerBodyGeneric"></md-textarea>


              
          </md-field>

          <md-button title="Copiar"  @click="copyText('mailerBodyGeneric')"><md-icon >file_copy</md-icon></md-button>

        </md-card-content>
      </md-card>
      </md-card-content>

    </md-card>

  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import copy from "../../../lib/copy.js";
export default {
  name: "Microservices",
  components: {},
  data() {
    return {
      token: "",
      mailer: "https://unabase.cc/mail",
      mailerBodyGmail: `{
        "to": "xxxxx@mail.com",
        "subject": "test for microservice serveless mailer from aws lambda",
        "html": "hello from the other side !!!",
        "pass": "xxxxxx",
        "user": "xxxx@gmail.com",
        "service": "gmail",
        "from": "Username  <xxxxx@mail.net>",
        "attachments": [
          {
            "filename": "test.pdf",
            "path": "url to file"
          }
          ]
        
      }`,
      mailerBodyGeneric: `{
        "to": "xxx@mail.com",
        "subject": "test for microservice serveless mailer from aws gener",
        "html": "hello from the other side !!!",
        "user": "user@domain.com",
        "pass": "xxxxxx",
        "host": "mail.domain.com",
        "port": 8080,
        "ignoreTLS": true,
        "from": "Username  <user@domain.com>",
        "attachments": [
          {
            "filename": "test.pdf",
            "path": "url to file"
          }
          ]
        
      }`
    };
  },
  computed: {
    ...mapGetters({
      getUser: "users/user"
    })
  },
  methods: {
    request() {
      axios(`https://unabase.cc/token/${this.getUser.email}`)
        .then(res => {
          this.token = res.data.token;
        })
        .catch(err => {});
    },
    copyText(element) {
      copy(element, true);
    }
    // copy(element) {
    //   /* Get the text field */

    //   let copyText = document.getElementById(element);
    //   copyText.disabled = false;

    //   /* Select the text field */
    //   copyText.select();

    //   /* Copy the text inside the text field */
    //   document.execCommand("copy");

    //   // copyText.setAttribute("disable", true);
    //   copyText.blur();

    //   copyText.disabled = true;
    // }
  }
};
</script>
<style scoped>
.md-card.card-inline {
  width: 600px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
</style>
